import {useCallback, useEffect, useRef, useState} from 'react'
import {Button, Divider, Form, Spin} from 'antd'

import {findChannelById, getFileUrlPrefix} from '@/services/channelManagement'
import {SFormImagesList, SGeneralForms} from 'shj-components'
import {useSetState} from "ahooks";
import {departmentTree} from "@/services/content.ts";

interface IProps {
  id: string | number
  visibleDrawer: boolean
  onClose?: () => void
  options: Record<string, any>
}

export default function FluxChannelInfo(props: IProps) {
  const formRef = useRef<any>()
  const {id, visibleDrawer} = props
  const [allLoading, setAllLoading] = useState<any>(false)
  const [baseData, setBaseData] = useState<any>({})

  // 是否编辑
  const isEdit = useCallback(() => {
    return id && id !== 0
  }, [id])

  // 获取文件服务器路径
  const getFileUrl = () => {
    return getFileUrlPrefix()
  }
  // 默认赋值
  const initGetForm = useCallback(() => {
    {
      setBaseData({})
      if (isEdit()) {
        getFileUrl().then((fileIpUrl: any) => {
          getInfoById(id, fileIpUrl)
        })
      }
    }
  }, [id, isEdit]);

  const getInfoById = (id: string | number, fileIpUrl: any) => {
    setAllLoading(true)
    findChannelById(id, {
      queryOrg: true,
      queryEmployee: true,
      queryCategoryName: true,
      queryTypeName: true,
    })
      .then(response => {
        const data: Record<string, any> = response || {}
        // 文件处理
        if (Array.isArray(data.relateChannel?.relatePersonFiles)) {
          data.relateChannel?.relatePersonFiles.map((item: { filePath: string }) => {
            item.filePath = item.filePath?.includes('http') ? item.filePath : (fileIpUrl + item.filePath);
          })
        }
        data.orgNames = data.orgList ? data.orgList.map(item => item.name).join(', ') : '无'
        // debugger
        setBaseData(data)
        setAllLoading(false)
      })
      .catch(() => {
        setAllLoading(false)
      })
  }

  const onDownLoad = (templateId: any) => {
    const url = templateId + '?response-content-type=application/octet-stream'
    const a = document.createElement('a');
    a.style.display = 'none'
    a.href = url
    a.setAttribute('download', 'file')
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  // 渠道类型为关系人渠道
  const isRelated = () => baseData.channelExtType === 'RELATED'
  const renderIDCard = () => {
    const items: any = []
    const relatePersonFiles = baseData.relateChannel?.relatePersonFiles || [];
    if (relatePersonFiles && relatePersonFiles.length) {
      relatePersonFiles.map((item: any, index: number) => {
        const obj: any = {spanCol: 12}
        obj.children = (
          <Form.Item label={item.fileName} key={index}>
            <SFormImagesList value={[{url: item.filePath}]}/>
          </Form.Item>
        )
        items.push(obj)
      })
    }
    return items
  }

  useEffect(() => {
    if (visibleDrawer) {
      initGetForm()
    }
  }, [initGetForm, visibleDrawer])

  return (
    <Spin spinning={allLoading}>
      <SGeneralForms
        ref={formRef}
        detailsData={baseData}
        isDetail={true}
        configs={[
          {
            formItem: [
              {
                name: 'channelName',
                label: '渠道名称',
                spanCol: 24
              },
              {
                spanCol: 24,
                customRender: (
                  <Form.Item label="适用分公司">{baseData.orgNames}</Form.Item>
                ),
              },
              {
                name: 'cooperateModeName',
                label: '合作方式',
                spanCol: 12,
              },
              // {
              //   name: 'cooperateRangeName',
              //   label: '合作范围',
              //   spanCol: 12,
              // },
              {
                name: 'channelCategoryName',
                label: '渠道分类',
                spanCol: 12,
              },
              {
                name: 'typeName',
                label: '军种',
                spanCol: 12,
              },
              {
                name: 'activePassiveTypeName',
                label: '主被动属性',
                spanCol: 12,
              },
              // {
              //   name: 'contractTemplate',
              //   label: '合同模板',
              //   spanCol: 12,
              //   hidden: !baseData.contractTemplate,
              //   children: (
              //     <Button onClick={() => onDownLoad(baseData.contractTemplate)}>点击下载</Button>
              //   ),
              // },
              {
                spanCol: 24,
                customRender: <Divider style={{marginTop: 9}}/>,
              },
              // {
              //   name: 'description',
              //   label: '渠道介绍',
              //   spanCol: 24,
              // },
              // {
              //   name: 'advantage',
              //   label: '渠道优势',
              //   spanCol: 24,
              // },
              // {
              //   name: 'disadvantage',
              //   label: '渠道劣势',
              //   spanCol: 24,
              // },
              // {
              //   name: 'suggest',
              //   label: '渠道建议',
              //   spanCol: 24,
              // },
              {
                name: 'channelExtTypeName',
                label: '渠道类型',
                spanCol: 12,
              },
              {
                spanCol: 12,
                customRender: (
                  <Form.Item label="渠道税率(%)">{baseData.taxRate} %</Form.Item>
                ),
              },
              {
                name: 'operateCompanyName',
                label: '运营分公司',
                spanCol: 12,
              },
              {
                name: 'operateOrgName',
                label: '运营部门',
                spanCol: 12,
              },
            ],
          },
          {
            formItem: isRelated()
              ? [
                {
                  name: ['relateChannel', 'relatedRelegationName'],
                  label: '共享属性',
                  spanCol: 24,
                },
                {
                  name: ['relateChannel', 'payWayName'],
                  label: '薪酬体现',
                  spanCol: 12,
                },
                {
                  spanCol: 12,
                  customRender: () => {
                    const type = baseData.relateChannel?.payWay;
                    const value = baseData.relateChannel?.payValue;
                    if (type == 'PERCENT') {
                      return <Form.Item label="提点百分比">{value} %</Form.Item>
                    } else if (type == 'FIXED') {
                      return <Form.Item label="固定薪酬">{value} (元)</Form.Item>
                    }
                    return <div></div>;
                  },
                },
                {
                  spanCol: 24,
                  customRender: () => {
                    if (baseData.relateChannel?.relateCompanies?.length > 0) {
                      return <Form.Item
                        label="选择门店">{baseData.relateChannel?.relateCompanies?.map(item => item.name).join(", ")}</Form.Item>
                    } else if (baseData.relateChannel?.relateDepartmentInfo?.company) {
                      return <Form.Item
                        label="选择门店">{baseData.relateChannel?.relateDepartmentInfo?.company?.name}</Form.Item>
                    } else if (baseData.relateChannel?.relatePersonInfo?.company) {
                      return <Form.Item
                        label="选择门店">{baseData.relateChannel?.relatePersonInfo?.company?.name}</Form.Item>
                    }
                    return <div></div>;
                  },
                },
                {
                  spanCol: 24,
                  customRender: () => {
                    if (baseData.relateChannel?.relateDepartmentInfo?.departments?.length > 0) {
                      return <Form.Item
                        label="选择指定部门">{baseData.relateChannel?.relateDepartmentInfo?.departments?.map(item => item.name).join(", ")}</Form.Item>
                    }
                    return <div></div>;
                  },
                },
                {
                  spanCol: 24,
                  customRender: () => {
                    if (baseData.relateChannel?.relatePersonInfo?.employees?.length > 0) {
                      return <Form.Item
                        label="选择指定人员">{baseData.relateChannel?.relatePersonInfo?.employees?.map(item => item.userName).join(", ")}</Form.Item>
                    }
                    return <div></div>;
                  },
                },
                {
                  name: ['relateChannel', 'relatedName'],
                  label: '关系人姓名',
                  spanCol: 12,
                },
                {
                  name: ['relateChannel', 'relatedPhone'],
                  label: '关系人-电话号码',
                  layout: 'vertical',
                  spanCol: 12,
                },
                {
                  name: ['relateChannel', 'relatedIdCard'],
                  label: '关系人-身份证号码',
                  layout: 'vertical',
                  spanCol: 12,
                },
                {
                  name: ['relateChannel', 'relatedBankCard'],
                  label: '关系人-银行账户',
                  layout: 'vertical',
                  spanCol: 12,
                },
                {
                  name: ['relateChannel', 'relatedAccountBank'],
                  label: '关系人-开户行',
                  layout: 'vertical',
                  spanCol: 12,
                  maxLength: 30,
                },
                {
                  name: ['relateChannel', 'bankBranch'],
                  label: '关系人-银行网点',
                  layout: 'vertical',
                  spanCol: 12,
                  maxLength: 30,
                },
                {
                  name: ['relateChannel', 'bankAddr'],
                  label: '关系人-开户行地址',
                  layout: 'vertical',
                  spanCol: 12,
                  maxLength: 30,
                },
                {
                  name: ['relateChannel', 'bankBranchNo'],
                  label: '关系人-银行网点联行号',
                  layout: 'vertical',
                  spanCol: 12,
                  maxLength: 30,
                },
                ...renderIDCard(),
              ]
              : [],
          },
        ]}
      />
    </Spin>
  )
}
